module.exports = __webpack_public_path__ + "img/question11c2.5ce9da78.png";